import { render, staticRenderFns } from "./addressArchives.vue?vue&type=template&id=4e146215&scoped=true&"
import script from "./addressArchives.vue?vue&type=script&lang=js&"
export * from "./addressArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e146215",
  null
  
)

export default component.exports